/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Members_Reactivate_DescriptionInputs */



/**
* | output |
* | --- |
* | "{email} will be able to sign in again and everything they had before is available without reconnecting. This takes a seat." |
*
* @param {Members_Reactivate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_reactivate_description = /** @type {((inputs: Members_Reactivate_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Reactivate_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} kann sich wieder anmelden, und alles Bisherige ist ohne erneutes Verbinden verfügbar. Dies belegt einen Platz.`)
	return /** @type {LocalizedString} */ (`${i?.email} will be able to sign in again and everything they had before is available without reconnecting. This takes a seat.`)
});